module.exports = __webpack_public_path__ + "media/npc_dota_hero_dawnbreaker.9249da95.webm";